import { render, staticRenderFns } from "./CarwashContextMenu.vue?vue&type=template&id=5f983342&"
import script from "./CarwashContextMenu.vue?vue&type=script&lang=js&"
export * from "./CarwashContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports